import generateId from '../../../common/utils/generate-id.js'

export default generateId
